import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MisTareasContent } from './components/MisTareasContent';

export default function MisTareas() {
    return (
        <MainContent
            component={<MisTareasContent />}
            titulo='Mis Tareas'
            noBackground
            tableMaxWidth
        />
    );

};
